<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n';
import { defineAsyncComponent, onMounted, ref } from 'vue';
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
const t = i18n.global.t

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const Link = defineAsyncComponent(() => import('@/views/components/Link.vue'));
const CommentQuote = defineAsyncComponent(() => import('vue-material-design-icons/CommentQuote.vue'));
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const header_image = `${VITE_ASSET_URL}assets/public/assets/img/blog/serrurierIame1000x600.webp`

let activeSlide = ref(0)
let slideItemsPerPage = ref(2)
const isClient = ref(false)

onMounted(() => {
    isClient.value = true
    isProAuthenticated.value = getAuthStatus()
})

const flip_card_data = [
    {
        title: "Devis précis en un instant",
        description: "Générez des devis complets en quelques clics. Topela vous aide à structurer vos offres avec des descriptifs clairs et des montants justes. ",
        icon_name: "timer"
    },
    {
        title: "Signature électronique intégrée",
        description: "Validez vos devis en ligne pour une démarche professionnelle et rapide. Offrez à vos clients une expérience moderne et simplifiée. ",
        icon_name: "contract_edit"
    },
    {
        title: "Mises à jour automatiques des taux de TVA",
        description: "Restez conforme sans effort, quel que soit le type de travaux. Topela ajuste automatiquement les taux de TVA pour garantir l’exactitude de vos factures.",
        icon_name: "sync"
    },
    {
        title: "Optimisez vos factures en sous-traitance",
        description: "Intégrez facilement vos partenaires, suivez l’évolution des prix et optimisez vos marges. Tout se fait au même endroit, simplement. ",
        icon_name: "handshake"
    },
    {
        title: "Suivi de chantier du début à la fin",
        description: "De la première estimation à la livraison, Topela vous accompagne pas à pas pour une expérience fluide et maîtrisée.",
        icon_name: "engineering"
    },
    {
        title: "Facilité d’utilisation",
        description: "Pas besoin d’être un expert en informatique pour utiliser notre logiciel. De plus, Topela synchronise automatiquement vos données, que vous soyez sur un chantier ou en déplacement.",
        icon_name: "smartphone"
    },
    {
        title: "Marketplace intégrée",
        description: "Développez votre activité grâce à notre réseau d’opportunités. En moyenne, bénéficiez d’un projet tous les deux mois et faites grandir votre entreprise avec Topela.",
        icon_name: "local_mall"
    }
]

const screenshots = [
    {
        title: "Devis",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/screenshotDevis_g.webp`,
    },
    {
        title: "Factures",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ScreenshotF_acture.webp`,
    },
    {
        title: "Marketplace",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/screenshotMarketplace.webp`,
    }
]

const isProAuthenticated = ref(false)

function subscribeToTopela() {
    window.open(isProAuthenticated.value ? '/ps/home/' : '/ps/home/?next=singupScreenRoute', '_blank');
    // @ts-ignore
    window.dataLayer.push({
        event: "Lead",
        lead_source: "Pro subscription button",
        page_url: window.location.href,
    });
}

const getAuthStatus = (): boolean => {
    let userData = localStorage.getItem("flutter.authResponse")
    if (userData && !isMobileDevice()) {
        return true
    } else {
        return false
    }
}

function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

const flipCard = (idx: number) => {
    // Select all flip cards and reset them
    document.querySelectorAll(".flip-card-inner").forEach((card) => {
        (card as HTMLElement).style.transform = "rotateY(0deg)";
        card.classList.remove("flipped");
    });

    // Get the selected card
    const flipCard = document.getElementById(`flip-card-${idx}`);
    if (flipCard) {
        const flipCardInner = flipCard.querySelector(".flip-card-inner") as HTMLElement;
        if (flipCardInner) {
            // If the clicked card is already flipped, unflip it
            if (flipCardInner.classList.contains("flipped")) {
                flipCardInner.style.transform = "rotateY(0deg)";
                flipCardInner.classList.remove("flipped");
            } else {
                // Otherwise, flip it and ensure it's the only one flipped
                flipCardInner.style.transform = "rotateY(180deg)";
                flipCardInner.classList.add("flipped");
            }
        }
    }
};
</script>

<template>
    <Default>
        <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px">
            <div class="content-wrapper container bg-white h-100 pt-0 pt-md-5">
                <main id="main pt-5">
                    <div class="row my-2 my-lg-5">
                        <div class="col-lg-6 d-flex flex-column justify-content-center pe-3">
                            <h5 class="mb-3 text-center text-lg-start d-none d-lg-block">Gagnez du temps et optimisez votre gestion</h5>
                            <h5 class="mb-3 text-center text-lg-start d-block d-lg-none">Gagnez du temps et optimisez votre gestion</h5>
                            <h3 class="mb-4 mb-lg-3 text-center text-lg-start">Topela : Le logiciel de devis et factures pour serrurier - métallier</h3>
                            <p class="mb-4 d-none d-lg-block">
                                Topela n’est pas un simple logiciel administratif. C’est votre allié de confiance qui vous libère du fardeau des papiers pour vous laisser vous concentrer sur l’essentiel : sécuriser, réparer, fabriquer et installer avec précision.
                            </p>
                            <div>
                                <button class="btn primary-btn w-100 d-block d-lg-none mb-5" @click="subscribeToTopela">
                                    {{ isProAuthenticated ? t('w_txt_psHome_pro_space') :
                                        t('w_act_psHome_subscribe_to_topela') }}
                                </button>
                                <button class="btn primary-btn d-none d-lg-block" @click="subscribeToTopela">
                                    {{ isProAuthenticated ? t('w_txt_psHome_pro_space') :
                                        t('w_act_psHome_subscribe_to_topela') }}
                                </button>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img class="rounded-2" :src=header_image style="width: 100%; aspect-ratio: 10 / 6;"
                                alt="Service peintre batiment">
                        </div>
                    </div>

                    <!-- <img class="mt-5 rounded-4 d-none d-lg-block"
                        :src="VITE_ASSET_URL + 'assets/public/assets/img/blog/Banner-Topela-Service.webp'"
                        style="width: 100%; aspect-ratio: 16 / 5;" alt="Topela Service"> -->

                    <section>
                        <div class="row">
                            <div class="d-none d-lg-block col-lg-3 pe-5">
                                <div v-for="screenshot in screenshots" class="mb-5">
                                    <h5>{{ screenshot.title }}</h5>
                                    <img class="mt-2 rounded-4" :src="screenshot.image"
                                        style="width: 100%; aspect-ratio: 4 / 5;">
                                </div>
                            </div>


                            <div class="col-lg-9 px-3 border-black border-top-0 border-end-0 border-bottom-0">
                                <div>
                                    <h3 class="mb-4">
                                        Pourquoi les serruriers-métalliers qui réussissent choisissent Topela ?
                                    </h3>

                                    <p class="mb-4">
                                        Topela vous aide à structurer vos devis, suivre vos chantiers et maîtriser votre trésorerie. C’est bien plus qu’un outil de gestion : c’est une extension naturelle de votre savoir-faire.
                                    </p>
                                </div>

                                <div class="row mt-5">
                                    <div class="col-lg-6 customAccordion">
                                        <div class="accordion" id="articleAccordion">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                                        aria-expanded="true" aria-controls="collapseOne">
                                                        Créer des devis détaillés et clairs
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Ajoutez facilement vos prestations (pose de serrures multipoints, blindage de portes, grilles de défense, structures métalliques, escaliers, garde-corps, etc.), ajustez vos marges et appliquez automatiquement les bons taux de TVA.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                        aria-expanded="false" aria-controls="collapseTwo">
                                                        Tenir compte de l’évolution des prix des matériaux
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Mettez à jour vos tarifs selon le coût de l’acier, des systèmes de verrouillage, de la quincaillerie ou des automatismes pour garantir des devis justes et rentables.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                        aria-expanded="false" aria-controls="collapseThree">
                                                        Gérer la facturation et les paiements en toute simplicité
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Envoyez vos factures en quelques clics, suivez les paiements et automatisez les relances pour garder une trésorerie saine.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                        aria-expanded="false" aria-controls="collapseFour">
                                                        Renforcer votre image professionnelle
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" class="accordion-collapse collapse"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Des devis propres, lisibles et bien présentés : vos clients gagnent confiance, vos chances de conclure augmentent.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                        aria-expanded="false" aria-controls="collapseFive">
                                                        Accéder à vos documents partout
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" class="accordion-collapse collapse"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Que vous soyez à l’atelier, en intervention ou dans votre véhicule, vos devis et factures vous suivent partout sur mobile, tablette ou PC.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapseSix"
                                                        aria-expanded="false" aria-controls="collapseSix">
                                                        Trouvez des chantiers
                                                    </button>
                                                </h2>
                                                <div id="collapseSix" class="accordion-collapse collapse"
                                                    data-bs-parent="#articleAccordion">
                                                    <div class="accordion-body">
                                                        Toutes les semaines, des particuliers recherchent un plombier ou un chauffagiste sur Internet, notamment sur Topela. Notre marketplace vous permet donc de trouver simplement des chantiers.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 mt-5 mt-lg-0">
                                        <img class="rounded-4 d-none d-lg-block"
                                            :src="VITE_ASSET_URL + 'assets/public/assets/img/blog/couvreurZingueur-400x400.webp'"
                                            style="width: 100%; aspect-ratio: 1 / 1;" alt="Logciel Devis Serrurier">
                                    </div>

                                    <div class="col-12 mt-5">
                                        <div class="p-4 bg-blue rounded-3 row align-items-center w-100 ms-1">
                                            <div class="text-white col-lg-12 d-flex align-items-center">
                                                <div>
                                                    <div class="rounded-circle border-white border-1 me-3 d-flex justify-content-center align-items-center"
                                                        style="width: 45px; height: 45px;">
                                                        <span class="material-symbols-outlined">lightbulb</span>
                                                    </div>
                                                </div>
                                                <div class="text-white">
                                                    Un devis bien structuré et envoyé rapidement augmente vos chances de
                                                    signer un projet de 34,3 %, selon nos chiffres !
                                                </div>
                                            </div>
                                            <!-- <div class="col-lg-4 text-center mt-2 mt-lg-0">
                                                    <Link href="/pro/" type="button" class="btn menu-bg rounded-pill px-3 text-white">En savoir plus</Link>
                                                </div> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-5 mb-3">
                                    <div class="col-lg-7">
                                        <h3 class="mb-3">Le logiciel idéal pour les serruriers-métalliers</h3>
                                        <p class="">Topela est pensé pour les artisans de terrain. Il répond aux besoins spécifiques des serruriers et métalliers qui jonglent entre urgence, conception et chantier.</p>
                                    </div>
                                    <div class="col-lg-4 d-none d-lg-block">
                                        <img class="rounded-4"
                                            :src="VITE_ASSET_URL + 'assets/public/assets/img/blog/Smartphone_Onboarding_App.webp'"
                                            style="width: 100%; aspect-ratio: 1 / 1;" alt="Smartphone Onboarding App">
                                    </div>
                                </div>

                                <div class="mt-5">
                                    <h4 class="mb-4">La gestion de l’administratif avec Topela</h4>
                                    <div class="row">
                                        <div v-for="flip_item, idx in flip_card_data"
                                            class="col-lg-4 mb-4 d-flex justify-content-center">
                                            <div :id="'flip-card-' + idx" class="flip-card" @click="flipCard(idx)">
                                                <div class="flip-card-inner">
                                                    <div
                                                        class="flip-card-front bg-blue d-flex flex-column justify-content-center rounded-2 p-5">
                                                        <div class="d-flex justify-content-center mb-4">
                                                            <div>
                                                                <div class="rounded-circle bg-white d-flex justify-content-center align-items-center"
                                                                    style="width: 70px; height: 70px;">
                                                                    <span class="material-symbols-outlined"
                                                                        style="font-size: 36px;">{{ flip_item.icon_name
                                                                        }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h5 class="text-center text-white">
                                                            {{ flip_item.title }}
                                                        </h5>
                                                    </div>

                                                    <div class="flip-card-back bg-light-blue p-4 text-start rounded-2">
                                                        <p class="">
                                                            {{ flip_item.description }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="p-4 mt-5 bg-orange rounded-3 row align-items-center w-100 ms-1">
                                        <div class="text-white col-lg-8 d-flex align-items-center">
                                            <div>
                                                <div class="rounded-circle border-white border-1 me-3 d-flex justify-content-center align-items-center"
                                                    style="width: 45px; height: 45px;">
                                                    <span class="material-symbols-outlined">neurology</span>
                                                </div>
                                            </div>
                                            <div class="text-white">
                                                Découvrez comment Topela simplifie la vie des <strong>artisans serruriers et métalliers.</strong>

                                            </div>
                                        </div>
                                        <div class="col-lg-4 text-center mt-2 mt-lg-0">
                                            <Link href="/pro/" type="button"
                                                class="btn menu-bg rounded-pill px-3 text-white">En savoir plus</Link>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-1 d-block d-lg-none">
                                    <Carousel :autoplay="isClient ? 5000 : 0" :wrap-around="true" :itemsToShow="slideItemsPerPage"
                                        :transition="1000" snapAlign="start" class="custom-carousel row"
                                        v-model="activeSlide">
                                        <Slide v-for="screenshot, idx in screenshots" :key="idx" class="col-md-4 pe-4">
                                            <div class="carousel__item h-100 py-2">
                                                <div class="h-100" style="height: 8rem;">
                                                    <h4 class="text-start">{{ screenshot.title }}</h4>
                                                    <img class="mt-2" :src="screenshot.image"
                                                        style="width: 100%; aspect-ratio: 4 / 5;">
                                                </div>
                                            </div>
                                        </Slide>
                                    </Carousel>
                                </div>

                                <div class="mt-1 mt-lg-5">
                                    <h3 class="mb-3">
                                        Spécialement conçu pour votre métier de serrurier-métallier
                                    </h3>
                                    <h3 class="mb-3">
                                        Des devis qui ouvrent les portes
                                    </h3>
                                    <p class="mb-4">
                                        Fini les heures perdues à chercher des descriptions. Topela propose une bibliothèque adaptée à votre métier. Vous installez une porte blindée Fichet ? Une grille en acier sur mesure ? Cochez, personnalisez, c’est prêt.
                                    </p>
                                    <p class="mb-4">
                                        Regroupez vos prestations comme vous assemblez vos pièces en atelier. Une intervention complète ? Ajoutez déplacement, diagnostic, fourniture, pose, finitions… Le tout en quelques clics.
                                    </p>
                                    <p class="mb-4">
                                        Ajoutez des photos, croquis ou plans pour rassurer le client. Vous êtes pro ? Montrez-le dès le devis.
                                    </p>
                                    
                                </div>
                                <div class="mt-1 mt-lg-5">
                                   
                                    <h3 class="mb-3">
                                        Topela a de quoi vous faire rester zen
                                    </h3>
                                    <p class="mb-4">
                                        Topela est accessible par un nombre illimité d’utilisateurs et est utilisable depuis Internet. Consultez et modifiez vos devis sur mobile, tablette ou PC, même à plusieurs.
                                    </p>
                                    <p class="mb-4">
                                        Sur le chantier, besoin d’une info après un appel client ? Un coup d’œil sur Topela, c’est votre bureau dans votre poche.
                                    </p>
                                    <p class="mb-4">
                                        Fin de mois, appel du comptable : un clic, tout est prêt. Vous, vous restez sur le toit. Lui, il reste bouche bée.
                                    </p>
                                    <p class="mb-4">
                                        Pendant ce temps-là, vos concurrents galèrent avec leurs modèles Word ou Excel...
                                    </p>
                                    
                                </div>

                                <div class="mt-5">
                                    <div class="p-4 mt-5 rounded-3 row align-items-center w-100 ms-1 bg-blue">
                                        <div class="text-white col-lg-9 d-flex align-items-center">
                                            <div class="me-4">
                                                <div class="rounded-circle border-white border-1 d-flex justify-content-center align-items-center"
                                                    style="width: 60px; height: 60px;">
                                                    <!-- <span class="material-symbols-outlined">neurology</span> -->
                                                    <comment-quote class="text-white" />
                                                </div>
                                            </div>
                                            <div class="text-white">
                                                « Topela est un excellent outil. Ayant conscience, par expérience, de
                                                l’importance des devis, je peux désormais me concentrer pleinement sur
                                                mon métier, car je sais que tout ce qui sort de Topela est conforme. »
                                                <br><br>
                                                <strong>Frédéric, Artisan Ambassadeur</strong>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 text-center mt-2 mt-lg-0">
                                            <Link href="/pro/" type="button"
                                                class="btn menu-bg rounded-pill px-3 text-white">En savoir plus</Link>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-5">
                                    <h3 class="mb-3">
                                        FAQ : Tout ce que vous devez savoir sur les logiciels de devis pour serruriers-métalliers
                                    </h3>

                                    <div class="accordion" id="faqAccordion">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne" aria-expanded="true"
                                                    aria-controls="collapseOne">
                                                    Combien de temps pour maîtriser Topela ?
                                                </button>
                                            </h2>
                                            <div id="collapseOne" class="accordion-collapse collapse show"
                                                data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    La prise en main est immédiate. 87% de nos utilisateurs créent leur premier devis en moins de 15 minutes. Notre formation personnalisée vous accompagne dans les premiers pas.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo">
                                                    Puis-je travailler hors ligne ?
                                                </button>
                                            </h2>
                                            <div id="collapseTwo" class="accordion-collapse collapse"
                                                data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Non. L’app mobile ne fonctionne pas sans réseau (4G ou Wi-Fi).
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                    aria-expanded="false" aria-controls="collapseThree">
                                                    Puis-je utiliser Topela sur mobile et tablette ?
                                                </button>
                                            </h2>
                                            <div id="collapseThree" class="accordion-collapse collapse"
                                                data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Absolument. Topela est pensé pour être utilisé partout, même depuis un chantier.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                    aria-expanded="false" aria-controls="collapseFour">
                                                    Puis-je personnaliser entièrement mes documents ? 
                                                </button>
                                            </h2>
                                            <div id="collapseFour" class="accordion-collapse collapse"
                                                data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Absolument. Intégrez votre logo, vos conditions générales et adaptez la mise en page selon votre image professionnelle.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                    aria-expanded="false" aria-controls="collapseFive">
                                                    Existe-t-il un forfait pour plusieurs collaborateurs ? 
                                                </button>
                                            </h2>
                                            <div id="collapseFive" class="accordion-collapse collapse"
                                                data-bs-parent="#faqAccordion">
                                                <div class="accordion-body">
                                                    Eh bien oui, Topela est accessible par un nombre illimité d’utilisateurs. Si vous travaillez avec votre conjointe, par exemple, qui s’occupe de l’administratif, ce n’est pas un souci : vous pouvez travailler en même temps sur Topela.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    </Default>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.hero-background {
    height: 60vh;
    /* background-position: 25% center !important; */
    background-repeat: no-repeat !important;
    background-size: cover !important;
    margin-top: 5vh;
    position: relative;
}

ul {
    list-style-type: disc !important;
    /* Ensures bullets appear */
    padding-left: 20px;
    /* Adds space for bullets */
}

ul li {
    list-style: disc;
}

li {
    margin-bottom: 5px;
    /* Adds spacing between items */
}

li::marker {
    color: black !important;
    /* Sets bullet color to black */
    font-size: 1em;
    /* Adjusts bullet size (optional) */
}

.primary-btn {
    background-color: #49AFDA;
    color: white;
    border-radius: 10px;
}

.customAccordion .accordion {
    background: white;
}

.customAccordion .accordion-item {
    border: none;
    background: white;
}

.customAccordion .accordion-button {
    background: white;
    box-shadow: none;
    padding-left: 2rem;
    position: relative;
    font-weight: bold;
}

.customAccordion .accordion-button::after {
    display: none;
    /* Remove Bootstrap default arrow */
}

.customAccordion .accordion-button::before {
    content: '+';
    font-size: 1.5rem;
    font-weight: bold;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.customAccordion .accordion-button:not(.collapsed)::before {
    content: '−';
    /* Minus sign when opened */
}

.customAccordion .accordion-button.collapsed {
    border-bottom: 2px solid #ddd;
    /* Border under the title text only */
}

.customAccordion .accordion-body {
    padding-left: 2rem;
    /* Align content text with title */
}


/* The flip card container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
.flip-card {
    background-color: transparent;
    width: 300px;
    height: 275px;
    border: 1px solid #f1f1f1;
    perspective: 1000px;
    /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
}

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    /* Safari */
    backface-visibility: hidden;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
    background-color: #bbb;
    color: black;
}

/* Style the back side */
.flip-card-back {
    color: white;
    transform: rotateY(180deg);
}
</style>